import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Adityaraj Ingavale',
    title: "Ethical Hacker",
    desciption:"Hey, My Name is Adityaraj I am a CSE Student and I am A Passionate Ethical Hacker & Web developer from India. ",
    image: 'https://i.ibb.co/FHZGBgD/My-Beach-Pics-2.jpg',
    resumePdf: resume
}
